import { CreditIQEnvironment } from "Types/api/CreditIQ";

const STAGING_CIQ_SDK_URL = "https://checkout.staging.creditiq.com/ciq-sdk.js";
const PROD_CIQ_SDK_URL = "https://checkout.creditiq.com/ciq-sdk.js";

export const CONTINUE_DEAL_BASE_PATH = "/continue-deal";
export const INSTANT_APPROVAL_REVIEW_TIME = 120000;

export const CIQ_SDK_URL = {
    [CreditIQEnvironment.staging]: STAGING_CIQ_SDK_URL,
    [CreditIQEnvironment.prod]: PROD_CIQ_SDK_URL,
};
